/*
 *
 * KitStartCard
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 17-Mar-2025
*/

import KitStartCard from './KitStartCard'

export default KitStartCard
